<template>
  <div class="info-block">
    <div class="info-item">
      <div class="info-field">姓名</div>
      <div class="info-content">{{ user.name }}</div>
    </div>
    <div class="info-item">
      <div class="info-field">电话</div>
      <div class="info-content">{{ user.mobile }}</div>
    </div>
    <div class="info-item">
      <div class="info-field">邮箱</div>
      <div class="info-content">{{ user.email }}</div>
    </div>
    <div class="info-item">
      <div class="info-field">公司</div>
      <div class="info-content">
        <Tooltip :title="user.corpName" placement="topLeft">{{
          user.corpName
        }}</Tooltip>
      </div>
    </div>
    <div class="info-item">
      <div class="info-field">职位</div>
      <div class="info-content">{{ user.position }}</div>
    </div>
  </div>
</template>
<script>
import { Tooltip } from 'ant-design-vue'
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    Tooltip
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
.info-block {
  border-radius: 24px;
  border: 1px solid #edeff2;
  padding-top: 32px;
  padding-bottom: 32px;
  & > .info-item {
    .regular-font(16);
    display: flex;
    color: #333;
    line-height: 22px;
    align-items: center;

    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    & > .info-field {
      width: 88px;
      flex-shrink: 0;
      text-align: right;
    }

    & > .info-content {
      flex-grow: 1;
      text-align: left;
      margin-left: 32px;
      padding-right: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
